import { messageTypeByFileType } from '$func/file'

export function changeFileTypeToValidFileOrAudioMessageType(file: File) {
  if (['FILE', 'AUDIO'].includes(messageTypeByFileType(file.type))) return file
  return new File([file], file.name, { type: '' })
}

export function checkIfFileIsAMedia(file: File | undefined) {
  if (!file) return false
  return ['IMAGE', 'VIDEO'].includes(messageTypeByFileType(file.type))
}
